import { Button, Notification, Select, Loader, Input } from '@scuf/common';
import { getRmaStatus, getRmaStatusMf } from 'helpers';
import { blockedRmaStatusMf, statusOptionsMf, RmaModelMf, RmaModelLiteMf } from 'models';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import {
    Rma,
    REPAIR_CENTER,
    RmaLite,
    COMPANY_MANAGER,
    notificationAtom,
    companyDTO,
    RMAMANUFATURA,
    companyDtoAtom
} from 'resources';
import useFetch from 'helpers/hooks/useFetch';
import { CompanyDTO } from 'models/userManager/addCustomer';
import useUser from 'helpers/hooks/useUser';

interface ChangeStatusProps {
    rmaState: RmaModelLiteMf;
    setRmaState: React.Dispatch<React.SetStateAction<RmaModelLiteMf>>;
}

function ChangeStatus({ rmaState, setRmaState }: ChangeStatusProps): JSX.Element {
    const statusList = statusOptionsMf.filter(element => blockedRmaStatusMf.includes(element.value));
    const [currentStatus, setCurrentStatus] = useState(getRmaStatusMf(rmaState.statusId));
    const { t } = useTranslation(['common']);
    const { user } = useUser();
    const [observation, setObservation] = useState<string>('');

    const [_, sendUpdateStatusManufacturingEmail, loadingStatusEmail] = useFetch<
        {
            rmaId: number;
            statusId: any;
            email: string;
            cnpj: string;
            ssoId: string;
            companyName: string;
            observation: string;
        },
        { error: boolean; message: string }
    >({
        url: RMAMANUFATURA.updateStatusManufacturingSendEmail,
        method: 'POST',
        onError: 'Change',
        onSuccess: 'Change'
    });

    const [responseCompany, getCompanyById, loadingCompany] = useFetch<{ id: number | undefined }, CompanyDTO>({
        url: COMPANY_MANAGER.getCompanyById,
        method: 'GET',
        onError: 'EmailError'
    });

    return loadingStatusEmail == true ? (
        <Loader text="Carregando" />
    ) : (
        <div className="container-changes">
            <div className="container-selects">
                <Select
                    className="select"
                    options={statusList}
                    disabled
                    label={t('translation.From')}
                    placeholder={statusList.find(e => e.value === rmaState?.statusId)?.text}
                />
                <Select
                    className="select"
                    indicator="required"
                    placeholder={t('placeholders.Select.NewValue')}
                    options={statusList}
                    label={t('translation.To')}
                    onChange={val => {
                        setCurrentStatus(getRmaStatusMf(val));
                        getCompanyById({ id: rmaState.companyId });
                    }}
                />
            </div>
            <Input
                placeholder="Observação"
                label="Observação"
                value={observation}
                indicator="required"
                onChange={value => {
                    setObservation(value.trimStart());
                }}
                maxLength={500}
            />
            <div className="container-button">
                <Button
                    content={t('actions.Change')}
                    disabled={currentStatus?.value === rmaState.statusId || observation == ''}
                    loading={loadingCompany || loadingStatusEmail}
                    onClick={async () => {
                        await sendUpdateStatusManufacturingEmail({
                            rmaId: rmaState.id,
                            statusId: currentStatus!.value,
                            email: responseCompany?.data?.users?.find(x => x.ssoId === rmaState.ssoId)?.email,
                            cnpj: responseCompany?.data?.cnpj!,
                            ssoId: user?.ssoid || '-',
                            companyName: responseCompany?.data?.name!,
                            observation: observation
                        });
                        setRmaState({ ...rmaState, statusId: currentStatus?.value! });
                    }}
                />
            </div>
        </div>
    );
}
export default ChangeStatus;
